/** @jsx h */
import { Component, h, JSX } from 'preact';
import {
  sendAnalyticsTrack,
  sendCreativeExpand
} from '../../../../../../common/js/TrackAnalyticsHelper';
import { RootStore } from '../../../../../../common/js/stores/root.store';
import CustomizedControl from '../../../../../../common/components/customized-control';
import ExpandControl from '../../../../../../common/components/expand-control';

interface ControlStyle {
  backgroundColor: string;
  backgroundOpacity: number;
  labelColor: string;
  labelOpacity: number;
}

interface ExpandItemProps {
  onToggleExpand: (isExpanded: boolean) => void;
  controlStyle: ControlStyle;
  iconSize: number;
  iconPadding: number;
}

export class ExpandItem extends Component<ExpandItemProps> {
  constructor(props: ExpandItemProps) {
    super(props);
  }

  render(): JSX.Element {
    const { onToggleExpand, controlStyle, iconSize, iconPadding } = this.props;
    const isExpanded = RootStore.getInstance().videoStore.isVideoExpanded.value;
    return (
      <div data-zone="expand">
        <CustomizedControl
          id="expand"
          onTouchStart={(e: TouchEvent) => e.stopPropagation()}
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            sendAnalyticsTrack(e, isExpanded ? 'collapse' : 'expand');
            sendCreativeExpand(isExpanded);
            onToggleExpand(isExpanded);
          }}
          controlStyle={controlStyle}
          style={{ padding: iconPadding }}
        >
          <ExpandControl iconSize={iconSize} />
        </CustomizedControl>
      </div>
    );
  }
}
